<p>
  Invite your team and start <br>
  collaboration!
</p>

<a [routerLink]="appUrls.getUrlMassInviteMembers()" (click)="toggleLeftMenu()" [skipLocationChange]="true">Invite to HYGGER</a>
